import React from 'react';
import { Row, Col, Image, Grid } from 'antd';
import noDataImage from "../../assets/images/no-data-image.svg"
import "./NoDataFound.scss"
import { useTranslation } from 'react-i18next';
import { useResponsiveText } from '../../utils/helpers/fontSize.helper';
import { colors } from '../../utils/colors/colors';
const { useBreakpoint } = Grid;

const NoDataFound: React.FC = () => {
    const { t } = useTranslation('common');
    const { getResponsiveStyle } = useResponsiveText();
    const screens = useBreakpoint();

    return (
        <Row justify="center" align="middle" style={{ height: "100%" }}>
            <Col span={24}>
                <Col style={getResponsiveStyle({ color: colors.blueitNavyBlue }, {
                    md: '18px',
                    lg: '18px',
                    xl: '20px',
                    xxl: '22px'
                })} className='custom-empty-title' span={24}>
                    {t("noDataFound")}
                </Col>
                <Col span={24} style={{ textAlign: 'center' }}>
                    <Image
                        width={screens.xxl ? 170 : screens.xl ? 150 : 130}
                        preview={false}
                        src={noDataImage}
                        style={{ objectFit: 'contain' }}
                    />
                </Col>
                <Col span={24} style={{ textAlign: 'center' }} className='custom-empty-description'>
                    <span style={getResponsiveStyle({ color: colors.blueitNavyBlue }, {
                        md: '14px',
                        lg: '14px',
                        xl: '16px',
                        xxl: '18px'
                    })}>{t("noDataDesc")}</span>
                </Col>
            </Col>
        </Row>
    );
};

export default NoDataFound;